import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "double-arrow--sprite",
  "use": "double-arrow--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"double-arrow--sprite\">\n<path d=\"M17.59 18L19 16.59L14.42 12L19 7.41L17.59 6L11.59 12L17.59 18Z\" />\n<path d=\"M11 18L12.41 16.59L7.83 12L12.41 7.41L11 6L5 12L11 18Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol